//store
import store from '../../Redux/store'

//base communication
import BaseCommunication from '../../Communication/BaseCommunication'

//actions/ constants
import { SEND_INVITATION_ACTION,ACCEPT_DECLINE_ACTION } from './Constants'
import { API_BASE_URL, API_URL, HttpMethod, OperationStatus } from '../../Communication/Constants'

export class CareCircleAction extends BaseCommunication {
	careCircleAction(requestData,callback) {
		// let role = API_URL.INVITE_SENIORS
		// if(data.role === CAREGIVERS){
        //    role = API_URL.INVITE_CAREGIVERS
		// }
		
		this.callAPI(
			SEND_INVITATION_ACTION,
			API_BASE_URL + API_URL.BASE_USER_URL+API_URL.INVITE_USER,
			HttpMethod.POST,
			requestData,
			apiResponse => {
				this.res = apiResponse
				if (apiResponse.status === OperationStatus.SUCCESS) {
					store.dispatch({
						type: SEND_INVITATION_ACTION,
						data: apiResponse.data,
						error:apiResponse.error
					})
				}
				callback(this.res)
			}
		)
	}

	acceptDeclineAction(requestData,loggedInUserId, callback) {
		this.callAPI(
			ACCEPT_DECLINE_ACTION,
			API_BASE_URL + API_URL.BASE_USER_URL + loggedInUserId.userid + API_URL.ACCEPT_DECLINE_INVITATIONS,
			HttpMethod.POST,
			requestData,
			apiResponse => {
				this.res = apiResponse
				if (apiResponse.status === OperationStatus.SUCCESS) {
					store.dispatch({
						type: ACCEPT_DECLINE_ACTION,
						data: apiResponse.data,
						error:apiResponse.error
					})
				}
				callback(this.res)
			}
		)
	}

	
}


